// Product data with real IDs from Supabase database
// Based on products shown in homepage screenshots

// YARNS - Real product IDs from Supabase

// Top Selling Yarns - Updated with new product selection
export const topSellingYarns = [
  "20fadbf7-e2d5-4564-a83d-20a417c68811", // Stylecraft Special DK
  "77c55a0d-c360-4f47-8d3d-405e7e65468f", // Krafty baby chenille
  "2022f667-0900-4e00-a250-5599e817d17c", // Krafty baby milk cotton
  "56bfb5dd-3b89-4cb3-9060-b39f6a5b5e9c", // Cicibebe cakes
  "4af6b9ca-40d6-4a5c-805d-29a468d0076f", // Papatya cakes
  "87198342-e4d1-4ab6-8bbb-e4bc2bdf5f0c", // Papaty angora batik
  "e46a7561-5629-4b39-9bc2-baf3c765a42e", // Cicibebe sweetie colors
];

// New Yarns - From 'NEW PRODUCTS' screenshot
export const newYarns = [
  "2022f667-0900-4e00-a250-5599e817d17c", // Krafty Baby Milk Cotton
  "56bfb5dd-3b89-4cb3-9060-b39f6a5b5e9c", // Cicibebe Cakes
  "30d90f18-576d-4461-b931-39d3b43bf58b", // Candy Baby
  "a3f26f42-86d0-4112-be77-86fde2c37160", // Krafty Baby Chenille Fine
  "12817202-f2cb-4753-8075-b26bd0751632", // Additional Yarn Product 1
  "0a7cfcb9-3fb5-4fe3-9e73-b7e5c5a8bb68", // Additional Yarn Product 3
  "61e7a1bb-472c-42b4-887d-9e9cec2610fb", // Additional Yarn Product 4
  "96a8b2a2-f892-4206-aaa1-5451c9d43871", // Additional Yarn Product 5
];

// ACCESSORIES - Real product IDs from Supabase

// Top Selling Accessories - From screenshots
export const topSellingAccessories = [
  "ce0b6979-0c2a-40d7-9475-7792926bf01e", // Pony Crochet Hook Set
  "f1320ae9-ae8e-421b-94c8-0b0047b21805", // 3D Punch Needle Set
  "4d6fe6ac-3cbd-409f-bcbd-c64422550de6", // Bag Buckles
  "76d86ebc-1f0d-45ec-8322-43b0bdad96dc", // Glossy Black Gunmetal Bag Chain with Lobster Clasp
];

// New Accessories - From screenshots
export const newAccessories = [
  "ce0b6979-0c2a-40d7-9475-7792926bf01e", // Pony Crochet Hook Set
  "f1320ae9-ae8e-421b-94c8-0b0047b21805", // 3D Punch Needle Set
  "4d6fe6ac-3cbd-409f-bcbd-c64422550de6", // Bag Buckles
  "76d86ebc-1f0d-45ec-8322-43b0bdad96dc", // Glossy Black Gunmetal Bag Chain with Lobster Clasp
];

// Fallback product data for when API fails
export const fallbackYarnProducts = [
  {
    id: "fallback-1",
    name: "Krafty Baby Milk Cotton",
    brand: "Krafty",
    category: "Cotton",
    price: 115,
    originalPrice: 125,
    rating: 4.5,
    reviews: 28,
    image: "/companies/krafty.jpg",
    badge: "TOP SELLING",
    link: "/products/krafty-baby-milk-cotton",
    slug: "krafty-baby-milk-cotton",
    variants: [
      {
        id: "fallback-variant-1",
        sku: "KBMC-001",
        price_regular: 115,
        price_sale: 115,
        stock: 50,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/companies/krafty.jpg",
            alt_text: "Krafty Baby Milk Cotton",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      { category: { id: "cotton", name: "Cotton", slug: "cotton" } },
    ],
    tags: [{ tag: { id: "soft", name: "Soft", slug: "soft", color: "blue" } }],
    images: [
      {
        url: "/companies/krafty.jpg",
        alt_text: "Krafty Baby Milk Cotton",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.5 }],
  },
  {
    id: "fallback-2",
    name: "Cicibebe Batik",
    brand: "Cicibebe",
    category: "Acrylic",
    price: 250,
    originalPrice: 275,
    rating: 4.7,
    reviews: 15,
    image: "/companies/cicibebe.jpg",
    badge: "NEW",
    link: "/products/cicibebe-batik",
    slug: "cicibebe-batik",
    variants: [
      {
        id: "fallback-variant-2",
        sku: "CB-001",
        price_regular: 250,
        price_sale: 250,
        stock: 30,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/companies/cicibebe.jpg",
            alt_text: "Cicibebe Batik",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      { category: { id: "acrylic", name: "Acrylic", slug: "acrylic" } },
    ],
    tags: [
      {
        tag: {
          id: "colorful",
          name: "Colorful",
          slug: "colorful",
          color: "purple",
        },
      },
    ],
    images: [
      {
        url: "/companies/cicibebe.jpg",
        alt_text: "Cicibebe Batik",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.7 }],
  },
  {
    id: "fallback-3",
    name: "Krafty Baby Chenille",
    brand: "Krafty",
    category: "Chenille",
    price: 280,
    originalPrice: 325,
    rating: 4.8,
    reviews: 42,
    image: "/companies/krafty.jpg",
    badge: "PREMIUM",
    link: "/products/krafty-baby-chenille",
    slug: "krafty-baby-chenille",
    variants: [
      {
        id: "fallback-variant-3",
        sku: "KBC-001",
        price_regular: 280,
        price_sale: 280,
        stock: 25,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/companies/krafty.jpg",
            alt_text: "Krafty Baby Chenille",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      { category: { id: "chenille", name: "Chenille", slug: "chenille" } },
    ],
    tags: [
      {
        tag: { id: "premium", name: "Premium", slug: "premium", color: "gold" },
      },
    ],
    images: [
      {
        url: "/companies/krafty.jpg",
        alt_text: "Krafty Baby Chenille",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.8 }],
  },
  {
    id: "fallback-4",
    name: "Krafty Baby Chenille Fine",
    brand: "Krafty",
    category: "Chenille",
    price: 189,
    originalPrice: 250,
    rating: 4.6,
    reviews: 35,
    image: "/companies/krafty.jpg",
    badge: "BEST SELLER",
    link: "/products/krafty-baby-chenille-fine",
    slug: "krafty-baby-chenille-fine",
    variants: [
      {
        id: "fallback-variant-4",
        sku: "KBCF-001",
        price_regular: 189,
        price_sale: 189,
        stock: 40,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/companies/krafty.jpg",
            alt_text: "Krafty Baby Chenille Fine",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      { category: { id: "chenille", name: "Chenille", slug: "chenille" } },
    ],
    tags: [
      {
        tag: {
          id: "bestseller",
          name: "Best Seller",
          slug: "bestseller",
          color: "green",
        },
      },
    ],
    images: [
      {
        url: "/companies/krafty.jpg",
        alt_text: "Krafty Baby Chenille Fine",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.6 }],
  },
];

export const fallbackAccessoryProducts = [
  {
    id: "fallback-acc-1",
    name: "Pony Crochet Hook Set",
    brand: "Pony",
    category: "Accessories",
    price: 485,
    originalPrice: 0,
    rating: 4.7,
    reviews: 156,
    image: "/needles.webp",
    badge: "PREMIUM QUALITY",
    link: "/products/pony-crochet-hook-set",
    slug: "pony-crochet-hook-set",
    variants: [
      {
        id: "fallback-acc-variant-1",
        sku: "PCH-001",
        price_regular: 485,
        price_sale: 485,
        stock: 20,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/needles.webp",
            alt_text: "Pony Crochet Hook Set",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      {
        category: {
          id: "accessories",
          name: "Accessories",
          slug: "accessories",
        },
      },
    ],
    tags: [
      {
        tag: { id: "premium", name: "Premium", slug: "premium", color: "gold" },
      },
    ],
    images: [
      {
        url: "/needles.webp",
        alt_text: "Pony Crochet Hook Set",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.7 }],
  },
  {
    id: "fallback-acc-2",
    name: "3D Punch Needle Set",
    brand: "CraftMaster",
    category: "Accessories",
    price: 399,
    originalPrice: 0,
    rating: 4.5,
    reviews: 89,
    image: "/needles_with_cloth.webp",
    badge: "CREATIVE TOOL",
    link: "/products/3d-punch-needle-set",
    slug: "3d-punch-needle-set",
    variants: [
      {
        id: "fallback-acc-variant-2",
        sku: "3DPN-001",
        price_regular: 399,
        price_sale: 399,
        stock: 15,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/needles_with_cloth.webp",
            alt_text: "3D Punch Needle Set",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      {
        category: {
          id: "accessories",
          name: "Accessories",
          slug: "accessories",
        },
      },
    ],
    tags: [
      {
        tag: {
          id: "creative",
          name: "Creative",
          slug: "creative",
          color: "purple",
        },
      },
    ],
    images: [
      {
        url: "/needles_with_cloth.webp",
        alt_text: "3D Punch Needle Set",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.5 }],
  },
  {
    id: "fallback-acc-3",
    name: "Bag Buckles",
    brand: "CraftMaster",
    category: "Accessories",
    price: 50,
    originalPrice: 0,
    rating: 4.3,
    reviews: 67,
    image: "/pattern.png",
    badge: "ESSENTIAL",
    link: "/products/bag-buckles",
    slug: "bag-buckles",
    variants: [
      {
        id: "fallback-acc-variant-3",
        sku: "BB-001",
        price_regular: 50,
        price_sale: 50,
        stock: 100,
        is_default: true,
        is_active: true,
        images: [
          {
            url: "/pattern.png",
            alt_text: "Bag Buckles",
            position: 1,
            is_primary: true,
          },
        ],
      },
    ],
    categories: [
      {
        category: {
          id: "accessories",
          name: "Accessories",
          slug: "accessories",
        },
      },
    ],
    tags: [
      {
        tag: {
          id: "essential",
          name: "Essential",
          slug: "essential",
          color: "blue",
        },
      },
    ],
    images: [
      {
        url: "/pattern.png",
        alt_text: "Bag Buckles",
        position: 1,
        is_primary: true,
      },
    ],
    reviews: [{ rating: 4.3 }],
  },
];

// Master product lists - Combined unique products from all arrays above
export const allYarnProducts = [
  {
    id: "2022f667-0900-4e00-a250-5599e817d17c",
    name: "Krafty Baby Milk Cotton",
    brand: "Krafty",
    category: "Cotton",
    price: 115,
    originalPrice: 125,
    rating: 4.5,
    reviews: 28,
    image: "/companies/krafty.jpg",
    badge: "TOP SELLING",
    link: "/products/krafty-baby-milk-cotton",
  },
  {
    id: "1f2e24ae-8ce1-4aac-8aab-5a1c2595baf0",
    name: "Cicibebe Batik",
    brand: "Cicibebe",
    category: "Acrylic",
    price: 250,
    originalPrice: 275,
    rating: 4.7,
    reviews: 15,
    image: "/companies/cicibebe.jpg",
    badge: "NEW",
    link: "/products/cicibebe-batik",
  },
  {
    id: "77c55a0d-c360-4f47-8d3d-405e7e65468f",
    name: "Krafty Baby Chenille",
    brand: "Krafty",
    category: "Chenille",
    price: 280,
    originalPrice: 325,
    rating: 4.8,
    reviews: 42,
    image: "/companies/krafty.jpg",
    badge: "PREMIUM",
    link: "/products/krafty-baby-chenille",
  },
  {
    id: "a3f26f42-86d0-4112-be77-86fde2c37160",
    name: "Krafty Baby Chenille Fine",
    brand: "Krafty",
    category: "Chenille",
    price: 189,
    originalPrice: 250,
    rating: 4.6,
    reviews: 35,
    image: "/companies/krafty.jpg",
    badge: "BEST SELLER",
    link: "/products/krafty-baby-chenille-fine",
  },
  {
    id: "56bfb5dd-3b89-4cb3-9060-b39f6a5b5e9c",
    name: "Cicibebe Cakes",
    brand: "Cicibebe",
    category: "Cakes",
    price: 275,
    originalPrice: 325,
    rating: 4.9,
    reviews: 23,
    image: "/companies/cicibebe.jpg",
    badge: "NEW ARRIVAL",
    link: "/products/cicibebe-cakes",
  },
  {
    id: "30d90f18-576d-4461-b931-39d3b43bf58b",
    name: "Candy Baby",
    brand: "ICE",
    category: "Acrylic",
    price: 200,
    originalPrice: 0,
    rating: 4.4,
    reviews: 18,
    image: "/companies/ice.jpg",
    badge: "TRENDING",
    link: "/products/candy-baby",
  },
];

export const allAccessoryProducts = [
  {
    id: "ce0b6979-0c2a-40d7-9475-7792926bf01e",
    name: "Pony Crochet Hook Set",
    brand: "Pony",
    category: "Accessories",
    price: 485,
    originalPrice: 0,
    rating: 4.7,
    reviews: 156,
    image: "/needles.webp",
    badge: "PREMIUM QUALITY",
    link: "/products/pony-crochet-hook-set",
  },
  {
    id: "f1320ae9-ae8e-421b-94c8-0b0047b21805",
    name: "3D Punch Needle Set",
    brand: "CraftMaster",
    category: "Accessories",
    price: 399,
    originalPrice: 0,
    rating: 4.5,
    reviews: 89,
    image: "/needles_with_cloth.webp",
    badge: "CREATIVE TOOL",
    link: "/products/3d-punch-needle-set",
  },
  {
    id: "4d6fe6ac-3cbd-409f-bcbd-c64422550de6",
    name: "Bag Buckles",
    brand: "CraftMaster",
    category: "Accessories",
    price: 50,
    originalPrice: 0,
    rating: 4.3,
    reviews: 67,
    image: "/pattern.png",
    badge: "ESSENTIAL",
    link: "/products/bag-buckles",
  },
];

// Create combined arrays for filtering
export const allProducts = [...allYarnProducts, ...allAccessoryProducts];
